import { cn } from "@omni/utils/styles";

import { useSearchBoxContext } from "@/components/Search/SearchBar/components/SearchBox/context/searchBox.context";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type Props = {
    className?: string;
};

export const Input = ({ className }: Props) => {
    const { inputRef, inputProps } = useSearchBoxContext();
    const { t } = useGranite();

    return (
        <input
            {...inputProps}
            id={"autocomplete-input"}
            className={cn(
                "tw:[&::-webkit-search-cancel-button]:appearance-none",
                className
            )}
            ref={inputRef}
            value={inputProps.value ?? ""}
            tabIndex={0}
            autoCapitalize={"none"}
            aria-label={t("accessibility.searchBox.label")}
        />
    );
};
